<div class="flex flex-col min-h-screen" style="
      background: linear-gradient(180deg, #1e1b3a 0%, #302676 60%, #4636b8 113.79%);
    ">
  <app-header></app-header>
  <div class="flex-1 flex items-center justify-center py-4 px-4 sm:px-6 lg:px-8">
    <div class="max-w-md w-full mt-16 bg-white shadow-lg rounded-lg overflow-hidden">
      <div class="p-8 pb-0 flex flex-col items-center justify-center">
        <div class="rounded-full mb-4 h-16 w-16 flex items-center justify-center text-primary-600 bg-primary-600/10">
          <i class="fa-solid fa-user-shield text-3xl"></i>
        </div>
        <h2 class="text-2xl font-semibold mb-2 text-center">Platform Superadmin</h2>
        <p class="text-secondary text-center">Sign in with your superadmin credentials.</p>
      </div>
      <form [formGroup]="loginForm" class="p-8 flex flex-col gap-6" (ngSubmit)="login()">
        <div class="flex flex-col gap-4">
          <mat-form-field appearance="outline" [hideRequiredMarker]="true">
            <mat-label>Username</mat-label>
            <input matInput placeholder="Username" formControlName="username" required>
            <small class="text-red-500" *ngIf="submitted && loginForm.get('username').hasError('required')">
              Username is required
            </small>
          </mat-form-field>
          <mat-form-field appearance="outline" [hideRequiredMarker]="true">
            <mat-label>Password</mat-label>
            <input [type]="inputType" formControlName="password" matInput required>
            <button (click)="toggleVisibility()" mat-icon-button matSuffix matTooltip="Toggle Visibility" type="button">
              <mat-icon *ngIf="visible" svgIcon="mat:visibility"></mat-icon>
              <mat-icon *ngIf="!visible" svgIcon="mat:visibility_off"></mat-icon>
            </button>
            <small class="text-red-500" *ngIf="submitted && loginForm.get('password').hasError('required')">
              Password is required.
            </small>
          </mat-form-field>
        </div>
        <p class="text-red-500 text-sm text-center -mt-2" *ngIf="errorMessage">{{ errorMessage }}</p>
        <button type="submit" color="primary" mat-raised-button
                class="w-full py-2 bg-primary-600 text-white rounded-lg">
          Log In
        </button>
        <p class="text-center -mt-2">
          <a class="text-primary-600 cursor-pointer text-sm" (click)="goTo('/auth/login')">
            Back to organisation login
          </a>
        </p>
      </form>
    </div>
  </div>
</div>
<app-footer></app-footer>
